"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeCheckPoints = void 0;
class TimeCheckPoints {
    static findPoint(name) {
        for (let i = 0; i < this.timePoints.length; i++)
            if (name == this.timePoints[i].name)
                return this.timePoints[i];
        return undefined;
    }
    static setCheckPoint(name) {
        let conf = this.findPoint(name);
        if (!conf) {
            this.timePoints.push({ name: name, timeValue: performance.now() });
        }
        else
            conf.timeValue = performance.now();
    }
    static getCheckPointTime(name) {
        let conf = this.findPoint(name);
        if (!conf) {
            return -1;
        }
        else
            return (performance.now() - conf.timeValue);
    }
    static removeChekPoint(name) {
        this.timePoints = this.timePoints.filter((conf) => { return conf.name != name; });
    }
}
TimeCheckPoints.timePoints = [];
exports.TimeCheckPoints = TimeCheckPoints;
//# sourceMappingURL=TimeCheckPoints.js.map